import { render } from "./moudle4_1.vue?vue&type=template&id=032506d0&ts=true"
import script from "./moudle4_1.vue?vue&type=script&lang=ts"
export * from "./moudle4_1.vue?vue&type=script&lang=ts"

import "./moudle4_1.vue?vue&type=style&index=0&id=032506d0&lang=scss&scope=true"

import exportComponent from "/Users/haoxunming/Desktop/flowbox公司项目/flowbox/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__